export enum SnapshotState {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  READY = 'READY',
  FAILED = 'FAILED',
}

export interface Snapshot {
  id: number
  name: string
  identifier: string
  date: string
  traceModel: { id: number }
  state?: SnapshotState
}

export interface SnapshotListItem {
  snapshotname: string
  id: number
  updated: string | undefined
}

export type SnaphotReference = number | 'latest'

export function asSnapshotReference(text: string | string[]): SnaphotReference {
  return text == 'latest' ? 'latest' : text instanceof Array ? parseInt(text[0]) : parseInt(text)
}
